import angular from 'angular';
import Home from './home/home';
import Login from './login/login';
import ChangePassword from './changePassword/changePassword';
import Main from './main/main';
import ResetPassword from './resetPassword/resetPassword';
import AuthPage from './auth/auth';
import EditProfile from './editProfile/editProfile';
import User from "./user/user";

let componentModule = angular.module('app.components', [
  //These two are needed for the app to work.
  Main,
  AuthPage,

  EditProfile,
  Home,
  Login,
  ChangePassword,
  ResetPassword,
  User
])

.name;

export default componentModule;



// WEBPACK FOOTER //
// ./client/app/components/components.js